module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-tags"
  }, [(_vm.tags.length) ? _c('ul', {
    staticClass: "list list-tags"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('li', {
      class: [_vm.hasTag(tag) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(tag)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tag.name))]), _vm._v(" "), (_vm.hasTag(tag)) ? _c('icon', {
      attrs: {
        "name": "cancel"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.tags_none')) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1c0fc6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Tags.vue
// module id = 600
// module chunks = 234